import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { App } from 'antd'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../../redux/context/company/selectors'
import budgetingScenarioQueryKeys from './budgetingScenarioQueryKeys'
import { unLockBudgetingScenario } from '../../service/budgetingScenarioService'
import { BudgetingScenario } from '../../types/BudgetingScenario'

export const useUnLockBudgetingScenario = () => {
  const companyId = useSelector(contextCompanyIdSelector)
  const queryClient = useQueryClient()
  const { notification } = App.useApp()
  const { t } = useTranslation()

  if (!companyId) {
    throw new Error('Company ID is required for locking budgeting scenarios.')
  }

  return useMutation({
    mutationKey: budgetingScenarioQueryKeys.list(companyId),
    mutationFn: (scenarioId: BudgetingScenario['id']) => {
      if (scenarioId === null) {
        throw new Error('Cannot unLock the default budgeting scenario.')
      }
      return unLockBudgetingScenario(companyId, scenarioId)
    },
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: budgetingScenarioQueryKeys.list(companyId) })
      notification.success({ message: t('message:UNLOCK_SCENARIO_SUCCESS') })
    },
    onError(error) {
      notification.error({ message: error.message })
    }
  })
}
